import { ConfiguratorContextType, configuratorGlobal } from '@/context';
import { animate } from '@lit-labs/motion';
import { consume } from '@lit/context';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('fg-mobile-header-main-image')
export class FgMobileHeaderMainImage extends LitElement {
  @property({ type: Object })
  selectedColor?: {
    image: string;
    color: string;
    selected: boolean;
    thumbImage: string;
  };

  @property({ type: Number })
  currentStep = 0;

  @property({ type: Boolean })
  colorStep?: boolean;

  @state()
  hideMainImage = false;

  @consume({ context: configuratorGlobal.context, subscribe: true })
  configuratorContext!: ConfiguratorContextType;

  renderMainImage(): string {
    const { productImage } = this.configuratorContext;

    if (
      (this.currentStep === 0 && productImage && !this.selectedColor) ||
      (this.currentStep === 0 && productImage && !this.selectedColor?.image)
    ) {
      return productImage;
    }

    if (!this.selectedColor) {
      return '';
    }

    const { image } = this.selectedColor;

    return image;
  }

  protected willUpdate(): void {
    if (this.currentStep === 0) {
      this.hideMainImage = false;
      return;
    }

    this.hideMainImage = true;
  }

  render() {
    return html`
      <div
        class=${`main-image ${
          this.hideMainImage || !this.colorStep ? 'hidden' : 'show'
        }`}
        ${animate({
          properties: ['height', 'max-height', 'opacity', 'transform'],
        })}
      >
        <img
          src=${this.renderMainImage()}
          alt=${this.selectedColor?.color || ''}
          width="240"
          height="240"
        />
      </div>
    `;
  }

  static styles = css`
    .main-image {
      overflow: hidden;
      height: auto;
      max-height: 0;
      opacity: 0;
      transform: translate3d(-300px, -240px, 0);
    }

    .main-image.show {
      height: auto;
      max-height: 240px;
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }

    .main-image img {
      display: block;
      margin: 0 auto;
      height: 240px;
      aspect-ratio: 1/1;
      object-fit: contain;
      width: auto;
      transform: scale(0.2);
    }

    .main-image.show img {
      transform: scale(1);
    }
  `;
}
